import { Notifier } from "@airbrake/browser";
import { config } from "src/config/config";
import { isDevelopment } from "src/shared/lib/env";

const airbrakeConfig = {
  projectId: 632245,
  projectKey: "8a67193b5dffbbe1af20b7e2b332a15e",
};

export const shouldNotifyError = !isDevelopment;

let airbrake: Notifier | null = null;

// 未ハンドリングエラーが通知されるように設定し、Notifier インスタンスを返します。
export function initAirbrake(): Notifier {
  if (airbrake !== null) {
    return airbrake;
  }

  airbrake = new Notifier({
    projectId: airbrakeConfig.projectId,
    projectKey: airbrakeConfig.projectKey,
    environment: config.APP_ENV ?? "unknown",
    instrumentation: {
      // new Notifier するだけで、未ハンドリングエラーの通知が行われるようになりますが、
      // 以下が false の場合には通知されません。
      onerror: shouldNotifyError,
      unhandledrejection: shouldNotifyError,
    },
  });

  return airbrake;
}

// airbrake は null の可能性がありますが、
// getAirbrake() では確実に Notifier インスタンスを取得できます。
export function getAirbrake(): Notifier {
  if (airbrake === null) {
    return initAirbrake();
  }
  return airbrake;
}
